import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import storageService from "../services/storage.service";
import moment from 'moment';
import CurrencyInput from 'react-currency-input';
import { useTranslation } from 'react-i18next'; 
import _ from 'lodash';
import { UtilService } from "../services/util.service";
import { number } from "yup";

export const LabelDynamic = (props) => {

  const { t } = useTranslation();

  const user = storageService.getUser();
  const formatoData = user.locale.formatDate.replaceAll('DD', 'dd');
  const formatoDataHora = user.locale.formatDateTime.replaceAll('DD', 'dd');

  const isInteger = (props.value_type === "I" ? true : false);
  const isDate = (props.value_type === "D" ? true : false);
  const isText = (props.value_type === "S" ? true : false);
  const isNumber = (props.value_type === "N" ? true : false);
  const isTime = (props.value_type === "T" ? true : false);
  const isBoolean = (props.value_type === "B" ? true : false);

  let value = null;
  if (isDate){
    value = UtilService.formatDate(props.value, formatoData);
  }
  else if (isTime){
    value = UtilService.formatDateTime(props.value, formatoDataHora);
  }
  else if (isInteger){
    value = UtilService.onlyNumber(props.value)
  }
  else if (isText){
    value = props.value
  }
  else if (isNumber){
    value = UtilService.formatNumberIdioma(props.value)
  }
  else if (isBoolean && props.value === true){
    value = t("YES")
  }
  else if (isBoolean && props.value === false){
    value = t("NO")
  }

return (
    <>
      <Form.Label>
        {value}
      </Form.Label>
    </>);
};